import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
  import { loadScript } from 'vue-plugin-load-script';
  import { GOOGLE_MAP_API_URL } from '@/constants';

  export interface IProps {
    longitude?: number;
    latitude?: number;
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    longitude: null,
    latitude: null
  },
  setup(__props: any) {

const props = __props as {
    longitude?: number;
    latitude?: number;
  }

  ;

  
  const root = ref();
  let loadMapPromise: Promise<google.maps.Map>;
  let marker: google.maps.Marker;

  const loadMap = async () => {
    await loadScript(GOOGLE_MAP_API_URL);
    return new google.maps.Map(root.value, {
      zoom: 8
    });
  };

  const setMap = async (center: { lat: number, lng: number }) => {
    const map = await loadMapPromise;
    map.setCenter(center);
    if (marker) {
      // 先去掉marker
      marker.setMap(null);
    }
    marker = new google.maps.Marker({
      position: center,
      icon: null,
      map
    });
  };

  onMounted(async () => {
    loadMapPromise = loadMap();
    if (props.latitude && props.longitude) {
      const center = { lat: props.latitude, lng: props.longitude };
      setMap(center);
    }
  });

  watch(
    [
      () => props.longitude,
      () => props.latitude
    ],
    ([lng, lat]) => {
      if (lng && lat) {
        setMap({ lng, lat });
      }
    }
  );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "map"
  }, null, 512))
}
}

})